<template>
    <v-container fluid>
        <v-layout row wrap>
            <v-flex xs12 class="text-center mb-5">
                <v-flex xs4 offset-xs4>
                    <v-card>
                        <v-container>
                            <div class="text-center">
                                <div>
                                    <img
                                        src="/img/logo_simple.png"
                                        style="width:150px;height:150px"
                                    />
                                </div>
                                <h3 class="primary--text bold mb-0 app-title">GateKeeper</h3>
                            </div>
                        </v-container>
                    </v-card>
                </v-flex>
            </v-flex>
            <v-flex md4 class="my-5">
                <v-flex md10 offset-md1>
                    <v-card :to="{ name: 'units' }">
                        <v-container>
                            <div class="text-center">
                                <div class="pa-2">
                                    <v-icon x-large>local_shipping</v-icon>
                                </div>
                                <h3 class="headline mb-0">Units</h3>
                            </div>
                        </v-container>
                    </v-card>
                </v-flex>
            </v-flex>
            <v-flex md4 class="my-5">
                <v-flex md10 offset-md1>
                    <v-card :to="{ name: 'calendar' }">
                        <v-container>
                            <div class="text-center">
                                <div class="pa-2">
                                    <v-icon x-large>event</v-icon>
                                </div>
                                <h3 class="headline mb-0">Calendar</h3>
                            </div>
                        </v-container>
                    </v-card>
                </v-flex>
            </v-flex>
            <v-flex md4 class="my-5" v-if="showDefects">
                <v-flex md10 offset-md1>
                    <v-card :to="{ name: 'defects' }">
                        <v-container>
                            <div class="text-center">
                                <div class="pa-2">
                                    <v-icon x-large>build</v-icon>
                                </div>
                                <h3 class="headline mb-0">Defects</h3>
                            </div>
                        </v-container>
                    </v-card>
                </v-flex>
            </v-flex>
            <v-flex md4 class="my-5" v-if="showBrakeChecks">
                <v-flex md10 offset-md1>
                    <v-card @click="$refs.brakereport.show()">
                        <v-container>
                            <div class="text-center">
                                <div class="pa-2">
                                    <v-icon x-large>insert_drive_file</v-icon>
                                </div>
                                <h3 class="headline mb-0">Brake Check Form</h3>
                            </div>
                        </v-container>
                    </v-card>
                </v-flex>
              <brake-check-report ref="brakereport"></brake-check-report>
            </v-flex>
            <v-flex md4 class="my-5" v-if="userIsFleetManager">
                <v-flex md10 offset-md1>
                    <v-card :to="{ name: 'configurations' }">
                        <v-container>
                            <div class="text-center">
                                <div class="pa-2">
                                    <v-icon x-large>settings</v-icon>
                                </div>
                                <h3 class="headline mb-0">Configurations</h3>
                            </div>
                        </v-container>
                    </v-card>
                </v-flex>
            </v-flex>
            <v-flex md4 class="my-5">
                <v-flex md10 offset-md1>
                    <v-card :to="{ name: 'users' }">
                        <v-container>
                            <div class="text-center">
                                <div class="pa-2">
                                    <v-icon x-large>people</v-icon>
                                </div>
                                <h3 class="headline mb-0">Users</h3>
                            </div>
                        </v-container>
                    </v-card>
                </v-flex>
            </v-flex>
            <v-flex md4 class="my-5" v-if="userIsFleetManager">
                <v-flex md10 offset-md1>
                    <v-card :to="{ name: 'service-requirements' }">
                        <v-container>
                            <div class="text-center">
                                <div class="pa-2">
                                    <v-icon x-large>list_alt</v-icon>
                                </div>
                                <h3 class="headline mb-0">Service Requirements</h3>
                            </div>
                        </v-container>
                    </v-card>
                </v-flex>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import CONFIG from '@/config';
import BrakeCheckReport from '@/components/BrakeChecks/BrakeCheckReport.vue';

export default {
    components: {
        BrakeCheckReport
    },
    data() {
        return {
            showDefects: CONFIG.featureToggles.defectsEnabled,
            showBrakeChecks: CONFIG.featureToggles.brakeCheckEnabled
        };
    }
};
</script>

<style lang="scss" scoped>
.app-title {
    font-size: 32px;
    line-height: 32px;
    padding-bottom: 6px;
}
</style>
